// extracted by mini-css-extract-plugin
export default {"main":"crPasw_main__LFFRm","text":"crPasw_text__GOOfN","form":"crPasw_form__NgUfU","codeLink":"crPasw_codeLink__WVCSv","error":"crPasw_error__5q56p"};